import type { ProvidersUserMeRetrieveResponse } from '@fireflyhealth/api'
import { GET_ME } from '../actions/actionTypes'
import type { MeAction } from '../actions/me'

export interface MeState {
  id: number | null
  first_name: string
  last_name: string
  email: string
  provider_fields: Pick<
    NonNullable<ProvidersUserMeRetrieveResponse['provider_fields']>,
    'tenant' | 'tenant_key' | 'internal_role' | 'practicing_states' | 'is_external'
  > | null
  assignee_group: Pick<NonNullable<ProvidersUserMeRetrieveResponse['assignee_group']>, 'id'> | null
}

const INITIAL_STATE: MeState = {
  id: null,
  first_name: '',
  last_name: '',
  email: '',
  provider_fields: null,
  assignee_group: null,
}

const me = (state = INITIAL_STATE, action: MeAction): MeState => {
  switch (action.type) {
    case GET_ME: {
      const { id, first_name, last_name, email, assignee_group, provider_fields } = action.me
      return {
        ...state,
        id,
        // The backend types some of these as optional, but they are effectively required.
        first_name: first_name ?? '',
        last_name: last_name ?? '',
        email: email ?? '',
        assignee_group: assignee_group ?? null,
        provider_fields: provider_fields ?? null,
      }
    }
    default:
      return state
  }
}

export default me
